import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class CommuncationsPermissions extends BaseScenesPermissions {
    constructor({ show = false, enabled = true } = {}) {
        super({ show, enabled })
    }
}

export default CommuncationsPermissions
